import React, { useState, useEffect } from 'react'
import { useListOrderForAdminQuery, useBulkInvoiceOrderMutation } from '../../../api/order.api';
import AdminTitle from '../../../common/AdminTitle/AdminTitle';
import LoadingComponent from '../../../common/Loading/Loading.component' 
import { Pagination } from 'flowbite-react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './AdminOrderPremium.css'

const OrdersList = () => {
    const [page, setPage] = useState(1);
    const [limit] = useState(15);
    const [searchInput, setSearchInput] = useState('');
    const [search, setSearch] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setSearch(searchInput.trim());
        }, 500);
        return () => clearTimeout(timer);
    }, [searchInput]);

    const { data, error, isLoading } = useListOrderForAdminQuery({ page, limit, search });
    const [bulkInvoice, { isLoading: isPrinting }] = useBulkInvoiceOrderMutation();

    const handleSelectAll = (e) => {
        if (e.target.checked && data?.result) {
            setSelectedItems(data.result.map(item => item._id));
        } else {
            setSelectedItems([]);
        }
    };

    const handleSelectItem = (orderId) => {
        setSelectedItems(prev => 
            prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]
        );
    };

    const isAllSelected = data?.result?.length > 0 && selectedItems.length === data.result.length;

    const handlePrintSelected = async () => {
        if (selectedItems.length === 0) return toast.warning('Select orders to print');
        try {
            const loadingToast = toast.info('Generating PDF on server...', { autoClose: false });
            
            const blob = await bulkInvoice(selectedItems).unwrap();
            
            // Create a blob and trigger download
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `maya_invoices_${Date.now()}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            
            toast.dismiss(loadingToast);
            toast.success('Invoices downloaded!');
        } catch (err) {
            console.error('Print error:', err);
            toast.error('Failed to generate PDF on server.');
        }
    };


    return (
        <div className="admin_margin_box">
        
        <div className='ma-order-page-wrapper'>
            <div className='ma-order-header'>
                <div className='ma-order-title-group'>
                    <AdminTitle label1='Order List' label2='' />
                    <h1>Order Repository</h1>
                </div>
                <div className='flex gap-3 items-center'>
                    <input
                        type="search"
                        className="ma-order-search-input"
                        placeholder="Search ID, Status, Name, or Phone"
                        value={searchInput}
                        onChange={(e) => { setSearchInput(e.target.value); setPage(1); }}
                    />
                    <Link to='/dashboard/add_manual_order'>
                        <button className='ma-order-btn-primary'>Create Order</button>
                    </Link>
                </div>
            </div>

            {selectedItems.length > 0 && (
                <div className='ma-order-content-card' style={{ marginBottom: '20px', padding: '12px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 600 }}>{selectedItems.length} orders highlighted</span>
                    <div className='flex gap-2'>
                        <button className='ma-order-btn-primary' onClick={handlePrintSelected} style={{ background: '#059669' }}>Download Invoices</button>
                        <button className='ma-order-btn-primary' onClick={() => setSelectedItems([])} style={{ background: 'transparent', border: '1px solid var(--ma-border)', color: '#000' }}>Dismiss</button>
                    </div>
                </div>
            )}

            <div className='ma-order-list-card'>        
                <table className='ma-order-table'>
                    <thead>
                        <tr>
                            <th style={{ width: '40px' }}>
                                <input type="checkbox" onChange={handleSelectAll} checked={isAllSelected} />
                            </th>
                            <th>SN</th>
                            <th>Reference</th>
                            <th>Customer Name</th>
                            <th>Products</th>
                            <th>Order Date</th>
                            <th>Qty</th>
                            <th>Net Total</th>
                            <th>Payment Type</th>
                            <th>Tracking Status</th>                            
                            <th style={{ textAlign: 'right' }}>Management</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="10"><LoadingComponent/></td></tr>
                        ) : error ? (
                            <tr><td colSpan="10" style={{ textAlign: 'center', color: '#f87171', padding: '40px' }}>Fail to load data.</td></tr>
                        ) : data?.result?.length > 0 ? (
                            data.result.map((row, index) => (
                                <tr key={row._id}>
                                    <td>
                                        <input type="checkbox" checked={selectedItems.includes(row._id)} onChange={() => handleSelectItem(row._id)} />
                                    </td>
                                    <td style={{ color: 'var(--ma-text-muted)' }}>{(page - 1) * limit + index + 1}</td>
                                    <td style={{ fontWeight: 600 }}>#{row.orderId}</td>
                                    <td style={{ fontWeight: 600 }}>{row.customer?.fullname || 'N/A'}</td>
                                    <td>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px' }}>
                                            {row.items && row.items.length > 0 ? (
                                                row.items.map((item, idx) => (
                                                    <div key={idx} style={{ whiteSpace: 'nowrap' }}>
                                                        <span style={{ fontWeight: 600 }}>{item.quantity}</span> - {item.title || 'Product'} - {item.size || 'N/A'}
                                                    </div>
                                                ))
                                            ) : (
                                                <span style={{ color: 'var(--ma-text-muted)' }}>N/A</span>
                                            )}
                                        </div>
                                    </td>
                                    <td>{new Date(row.createdAt).toLocaleDateString()}</td>
                                    <td>{row.items.reduce((acc, it) => acc + it.quantity, 0)}</td>
                                    <td>
                                        <div style={{ fontWeight: 700 }}>Rs. {Number(row.total || 0).toLocaleString()}</div>
                                        {Number(row.advancePayment || 0) > 0 && (
                                            <div style={{ fontSize: '11px', color: '#059669', fontWeight: 600 }}>
                                                Adv: Rs. {Number(row.advancePayment).toLocaleString()}
                                            </div>
                                        )}
                                        {Number(row.advancePayment || 0) > 0 && (
                                            <div style={{ fontSize: '11px', color: ((row.remainingAmount !== undefined ? Number(row.remainingAmount) : Math.max(0, (row.total || 0) - (row.advancePayment || 0))) <= 0) ? '#059669' : '#dc2626', fontWeight: 600 }}>
                                                {((row.remainingAmount !== undefined ? Number(row.remainingAmount) : Math.max(0, (row.total || 0) - (row.advancePayment || 0))) <= 0) ? 'Bal: Paid' : `Due: Rs. ${Number(row.remainingAmount !== undefined ? row.remainingAmount : Math.max(0, (row.total || 0) - (row.advancePayment || 0))).toLocaleString()}`}
                                            </div>
                                        )}
                                    </td>
                                    <td>
                                        <span className={`ma-order-badge`}>
                                            {row.paymentType==='Cash on delivery'?'COD':row.paymentType}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`ma-order-badge ${row.orderStatus?.toLowerCase()}`}>
                                            {row.orderStatus}
                                        </span>
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        <div className="ma-order-action-btns">
                                            <Link to={`/dashboard/order_view/${row._id}`}>
                                                <button className="ma-order-btn-view" title="View Order Details">
                                                    <span>👁️</span> View
                                                </button>
                                            </Link>
                                            <Link to={`/dashboard/order_edit/${row._id}`}>
                                                <button className="ma-order-btn-edit" title="Edit Order Details">
                                                    <span>✏️</span> Edit
                                                </button>
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr><td colSpan="11" style={{ textAlign: 'center', padding: '40px', color: 'var(--ma-text-muted)' }}>No records discovered.</td></tr>
                        )}
                    </tbody>
                </table>
                
                {data?.meta && data?.meta.total > limit && (
                    <div style={{ padding: '20px', display: 'flex', justifyContent: 'center' }}>
                        <Pagination
                            currentPage={data.meta.currentPage}
                            totalPages={Math.ceil(data.meta.total / limit)}
                            onPageChange={setPage}
                        />
                    </div>
                )}
            </div>
        </div>
        </div>
    )
}

export default OrdersList